import { ReturnStatement } from '@angular/compiler';
import { Question } from '../shared/question';
import { Response } from '../shared/response';
import { ApplicationStorage } from './applicationStorage';
//@ts-ignore
import moment from 'moment';

export class SurveyCall2Adoption {

    age: any;
    segment: any;
    endgame: boolean;
    surveyOutroText: any;
    keepAge: any;

    question1: Question;
    question2: Question;
    question3: Question;
    question4: Question;
    question5: Question;


    questions: Array<Question>;

    constructor(private applicationStorage: ApplicationStorage) {
        // this.surveyConsumerAgreement = false;//TODO
        this.endgame = false;

        //(0.1) 
        this.question1 = new Question(1, [],
            'Pe o scară de la 1 la 10 (1 fiind cel mai mic scor și 10 fiind cel mai mare), cum ai evalua interacțiunea cu consultantul Ploom?',
            '',
            'radio-inline',
            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10')
            ],
            false,
            'horizontal');



        //(0.3) 
        this.question2 = new Question(2, [1],  // 1a
            'Pe o scară de la 1 la 10 (1 fiind cel mai mic scor și 10 fiind cel mai mare), cât de satisfăcut(-ă) ai fost de modul în care ți s-a adresat consultantul Ploom?',
            '',
            'radio-inline',
            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10')
            ],
            false,
            'horizontal'
        );

        this.question2.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question1Responses = this.question1.responses.filter(r => r.selected);
            if (question1Responses.length > 0) {
                this.endgame = false;

                return true;
            } else {
                this.question2.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }


        this.question3 = new Question(3, [2],  // 1a
            'În cazul în care ai avut întrebări*, pe o scară de la 1 la 10 (1 fiind cel mai mic scor și 10 fiind cel mai mare), cum ai evalua calitatea răspunsurilor primite? ',
            '*În cazul în care nu ai avut întrebări, apasă "Next"',
            'radio-inline',
            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10'),
            new Response(10, 'Next')

            ],
            false,
            'horizontal'
        );

        this.question3.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question2Responses = this.question2.responses.filter(r => r.selected);
            if (question2Responses.length > 0) {
                this.endgame = false;

                return true;
            } else {
                this.question3.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }





        this.question4 = new Question(4, [3],  // 1a
            'Pe o scară de la 1 la 10 (1 fiind cel mai mic scor și 10 fiind cel mai mare), cât de utile consideri că au fost informațiile primite de la consultantul Ploom?',
            '',
            'radio-inline',
            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10')
            ],
            false,
            'horizontal'
        );

        this.question4.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question3Responses = this.question3.responses.filter(r => r.selected);
            if (question3Responses.length > 0) {
                this.endgame = false;

                return true;
            } else {
                this.question4.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }




        this.question5 = new Question(5, [4],  // 1a
            'Pe o scară de la 1 la 10 (1 fiind cel mai mic scor și 10 fiind cel mai mare), în ce măsură ai recomanda Ploom prietenilor tăi adulți, consumatori de produse din tutun și /sau țigarete electronice?',
            '',
            'radio-inline',
            [new Response(0, '1'),
            new Response(1, '2'),
            new Response(2, '3'),
            new Response(3, '4'),
            new Response(4, '5'),
            new Response(5, '6'),
            new Response(6, '7'),
            new Response(7, '8'),
            new Response(8, '9'),
            new Response(9, '10')
            ],
            false,
            'horizontal'
        );

        this.question5.render = () => {
            this.age = false;
            // console.log("1111: ", this.questionGateAge);
            let question4Responses = this.question4.responses.filter(r => r.selected);
            if (question4Responses.length > 0) {
                this.endgame = false;

                return true;
            } else {
                this.question5.responses.forEach(r => {
                    r.selected = false;
                });
                this.endgame = true;

            }
            return false;

        }

        this.questions = [this.question1, this.question2, this.question3, this.question4, this.question5];

        // console.log(this.questions)

    }


    getQuestions(): Array<Question> {
        return this.questions;
    }






}




